<div class="zn-layout dropdown">
  <zn-button
    [label]="localizationResource.LanguageService + '::' + selectedLayout?.name | abpLocalization"
    type="tertiary"
    size="normal"
    iconLeft="bi bi-columns-gap"
    iconRight="bi bi-chevron-down"
    [attr.data-bs-toggle]="'dropdown'"
    aria-expanded="false"
    [disabled]="isLoading()"
  >
  </zn-button>
  @if(permissions().canView) {
    <div class="dropdown-menu zn-dropdown">
    <ul class="zn-layout-list">
      <li class="zn-layout-list-header">
        <p>
          {{localizationResource.LanguageService + '::LayoutDropdownName' | abpLocalization}}
        </p>
        <p>
          {{localizationResource.LanguageService + '::LayoutDropdownFavorite' | abpLocalization}}
        </p>
      </li>
      @for (layout of layoutList; track $index) {
      <li>
        <p (click)="onSelectedLayoutChanged(layout)">
          {{localizationResource.LanguageService+'::' + layout.name | abpLocalization}}
        </p>
        <zn-button
          [class]="checkFavoriteIcon(layout.id )"
          type="tertiary"
          size="large"
          iconRight="bi bi-star-fill"
          (clicked)="updateFavoriteLayout(layout)"
        >
        </zn-button>
      </li>
      <hr class="zn-separator" />
      }
    </ul>
    @if(permissions().canCreate){
    <hr class="zn-separator" />
    <ul class="zn-layout-action-list">
      @if(permissions().canDelete){
        @if(!selectedLayout?.isBasic){
      <li>
        <zn-button
          class="zn-delete"
          [label]="localizationResource.LanguageService + '::LayoutDelete'| abpLocalization"
          type="tertiary"
          size="normal"
          (clicked)="deleteLayout()"
          [disabled]="selectedLayout?.isBasic ?? false"
        ></zn-button>
      </li>
      }
      } @if(selectedLayout?.isBasic && permissions().canEditBasic ||
      !selectedLayout?.isBasic && permissions().canEdit){
      <li>
        <zn-button
          [label]="localizationResource.LanguageService + '::LayoutEdit'| abpLocalization"
          type="tertiary"
          size="normal"
          (clicked)="openEditModal()"
        ></zn-button>
      </li>
      }
      <li>
        <zn-button
          [label]="localizationResource.LanguageService + '::LayoutCreate'| abpLocalization"
          type="tertiary"
          size="normal"
          (clicked)="openCreateModal()"
        ></zn-button>
      </li>
    </ul>
    }
  </div>
  }
</div>
<abp-modal
  [visible]="isVisible()"
  (visibleChange)="onVisibleChange($event)"
  (closed)="onVisibleChange(false)"
  [suppressUnsavedChangesWarning]="true"
>
  <ng-template #abpHeader>
    <div class="modal-header-title">
      <h3>
        {{ (isEditMode() ? localizationResource.LanguageService + '::LayoutEditTitle' :
        localizationResource.LanguageService + '::LayoutCreateTitle') | abpLocalization }}
      </h3>
      <h4>{{ localizationKey | abpLocalization }}</h4>
    </div>
  </ng-template>
  <ng-template #abpBody>
    <form [formGroup]="layoutForm" class="zn-form">
      <fieldset>
          <div class="row">
            <div class="col-12">
              <div class="form-control-container">
                <label class="form-label" for="layoutName">
                  {{ localizationResource.LanguageService + '::LayoutDropdownName' | abpLocalization }}
                  <span class="form-label-required">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="layoutName"
                  formControlName="layoutName"
                  placeholder="{{ localizationResource.LanguageService + '::LayoutNameEnter' | abpLocalization }}"
                />
              </div>
            </div>
          </div>
      </fieldset>
      <fieldset>
        <legend>
          {{ localizationResource.LanguageService + '::LayoutVisibility' | abpLocalization }}
          <hr />
          <div class="form-control-container form-check form-switch">
            <label class="form-check-label" for="isExclusive">
              ¿{{ localizationResource.LanguageService + '::LayoutShared' | abpLocalization }}?
            </label>
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              aria-checked="false"
              id="isExclusive"
              formControlName="isExclusive"
              [attr.aria-checked]="layoutForm.get('isExclusive')?.value ? 'true' : 'false'"
            />
          </div>
        </legend>
        @if (!this.isPersonal()) {
          <div class="row">
            <div class="col-12">
              <div class="col-12">
                <div class="form-control-container">
                  <label class="form-label" for="sharedRoles">
                    {{ localizationResource.LanguageService + '::LayoutSelectRoles' | abpLocalization }}
                    <span class="form-label-required">*</span>
                  </label>
                  <zn-multi-select
                    [options]="availableRoles"
                    formControlName="sharedRoles"
                    id="sharedRoles"
                  ></zn-multi-select>
                </div>
              </div>
            </div>
          </div>
        }
      </fieldset>
    </form>
  </ng-template>
  <ng-template #abpFooter>
    <zn-button
      type="secondary"
      (clicked)="onVisibleChange(false)"
      [label]="localizationResource.LanguageService + '::Cancel' | abpLocalization"
      [disabled]="isLoading()"
    ></zn-button>
    <zn-button
      type="primary"
      (clicked)="save()"
      [label]="localizationResource.LanguageService + '::Save' | abpLocalization"
      [disabled]="isLoading() || layoutForm.invalid"
    ></zn-button>
  </ng-template>
</abp-modal>
